import {useTranslation} from 'react-i18next';

import {Box} from '@mui/material';

import {ModulePageHeader} from '../../../../components/ModulePageHeader/ModulePageHeader';

export const WorkforceTargetProfilesPage = () => {
  const {t} = useTranslation('translation', {keyPrefix: 'workforceTargetProfilesPage'});

  return (
    <Box sx={{maxWidth: 1120, mx: 'auto', width: '100%'}}>
      <ModulePageHeader moduleName={t('breadcrumb')} title={t('title')} />
    </Box>
  );
};
